import React from "react";
import PropTypes from "prop-types";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { forbidExtraProps } from "utils";
import { ReactComponent as CloseIcon } from "assets/images/app_svg/close.svg";

function sidebar(props) {
  return (
    <div className="slider_sidebar">
      <Tooltip {...TOOLTIPS.slidingPopup.close}>
        <div className="slider_close flex_center" onClick={props.close}>
          <span className="icon">
            <CloseIcon />
          </span>
        </div>
      </Tooltip>

      {props.tabs !== undefined && props.tabs.length > 1 && (
        <ul className="slider_ul svg_icon">
          {props.tabs.map((val, i) => (
            <Tooltip key={i} {...TOOLTIPS.slidingPopup[val.key]}>
              <li
                className={[
                  "slider_li slider_li_" + ++i,
                  val.key === props.currentTab ? "active" : null
                ].join(" ")}
                value={val.key}
                onClick={() => props.selectTab(val.key)}
              >
                <span className="icon">
                  {React.createElement(val.icon)}
                  {val.iconHover && React.createElement(val.iconHover)}
                </span>
              </li>
            </Tooltip>
          ))}
        </ul>
      )}
    </div>
  );
}

sidebar.propTypes = forbidExtraProps(
  {
    tabs: PropTypes.array,
    currentTab: PropTypes.object
  },
  ["close", "selectTab"]
);

export default sidebar;
